import React from "react";
import PokemonSetTemplatePage from "../sets/PokemonSetTemplatePage";

export default function PerfectOrderPage() {
  return <PokemonSetTemplatePage setSlug="perfect-order" />;
}
